import "intersection-observer";

import { BootstrapVue } from 'bootstrap-vue'
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueToastr2 from "vue-toastr-2";
import paper from "paper";
import Loading from "vue-loading-overlay";
import VueTouch from 'vue-touch'
import { VLazyImagePlugin } from "v-lazy-image";
import axios from './libs/axios'

// Import only required Bootstrap JS modules to minimize vulnerable surface
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/tooltip";
import "bootstrap/js/dist/popover";
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "vue-toastr-2/dist/vue-toastr-2.min.css";
import "vue-loading-overlay/dist/vue-loading.css";

Vue.config.productionTip = false;

// const cors = require('cors')
// app.use(cors())

paper.install(window);

window.toastr = require("toastr");

Vue.use(BootstrapVue);
Vue.use(VueToastr2);
Vue.use(Loading);
Vue.use(VLazyImagePlugin);
Vue.use(VueTouch,{name:'v-touch'});

// Replace default axios with our custom instance
Vue.prototype.$http = axios

var host = window.location.hostname
var isXray = host.includes('xray')
var isDev = host.includes('dev') || host === 'localhost'
if (isXray) {
  document.title = isDev ? '🦴 [DEV] XAIMED X-ray Osteoporosis AI' : '🦴 XAIMED X-ray Osteoporosis AI'
} else {
  document.title = isDev ? '🔬 [DEV] XAIMED Retina AI DL-FAS' : '🔬 XAIMED Retina AI DL-FAS'
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
